<div class="product-card m-auto">
    <div class="row">
        <div *ngIf="product.media?.edges?.length > 0" class="col">
            <a class="image-wrapper multiple-images" (click)="goToPDP(product,$event)">
                <img [attr.alt]="product.title" class="front img-fluid"
                    [attr.view-transition-name]="product.media.edges[0]?.node?.image?.url"
                    [src]="product.media.edges[0]?.node?.image?.url + '&width=450'" />
                @if (product.media.edges[1]?.node?.image?.url) {
                <img [attr.alt]="product.title" class="back img-fluid"
                    [attr.view-transition-name]="product.media.edges[1]?.node?.image?.url"
                    [src]="product.media.edges[1]?.node?.image?.url + '&width=450'" />
                } @else {
                <img [attr.alt]="product.title" class="back img-fluid"
                    [attr.view-transition-name]="product.media.edges[0]?.node?.image?.url"
                    [src]="product.media.edges[0]?.node?.image?.url + '&width=450'" />
                }
            </a>
        </div>
    </div>
    <div class="row product-details">
        <div class="col">
            <div class="row mt-3">
                <div class="col">
                    <div class="align-content-center d-flex flex-nowrap flex-row title-group">
                        <div class="align-self-center d-flex justify-content-start">
                            {{product.title | titleWithoutColor | removeTaaBerry}}
                        </div>
                        <div class="align-self-center d-flex justify-content-end" hidden>
                            {{product.priceRange.maxVariantPrice.amount | currency:
                            product.priceRange.maxVariantPrice.currency}}
                        </div>
                    </div>
                </div>
                <!-- <div class="col-6 d-flex align-items-end justify-content-end">
                    <div class="price">
                        $300.00
                    </div>
                </div> -->
            </div>
            <div class="row mt-2">
                <div class="col">
                    <div class="divider"></div>
                </div>
            </div>
            <!-- <div class="row mt-2">
                <div class="col">
                    <app-rating-stars [rating]="product?.rating?.value"></app-rating-stars>
                </div>
            </div> -->
            <div class="row mt-2">
                <div class="align-items-center col-6 d-flex justify-content-start">
                    <div class="color-name">
                        color: {{product.title | colorWithoutTitle}}
                    </div>
                </div>
                <div class="align-items-center col-6 d-flex justify-content-end">
                    <div class="color" hidden>
                        style: {{product.style_name.value}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-product-swatches [product]="product" (selectedProduct)="onProductSelected($event)">
                    </app-product-swatches>
                </div>
            </div>
        </div>
    </div>

    <!-- <div
        style="left: 16px; top: 545px; position: absolute; color: black; font-size: 10px; font-family: Industry; font-weight: 400; text-transform: uppercase; line-height: 10px; letter-spacing: 0.50px; word-wrap: break-word">
        color: color name</div>
    <div style="width: 420.94px; left: 16px; top: 570px; position: absolute">
        
        <div
            style="width: 34.78px; height: 34.78px; left: 33.18px; top: 0px; position: absolute; background: #CED7D8; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 77.96px; top: 5.80px; position: absolute; background: #1D41FF; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 111.15px; top: 5.80px; position: absolute; background: #C3C3C3; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 144.33px; top: 5.80px; position: absolute; background: #9A4E4E; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 177.51px; top: 5.80px; position: absolute; background: #70CDAB; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 210.70px; top: 5.80px; position: absolute; background: #70CDAB; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 243.88px; top: 5.80px; position: absolute; background: #70CDAB; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 277.07px; top: 5.80px; position: absolute; background: #70CDAB; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 310.25px; top: 5.80px; position: absolute; background: #70CDAB; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div
            style="width: 23.18px; height: 23.18px; left: 343.44px; top: 5.80px; position: absolute; background: #70CDAB; border-radius: 9999px; border: 2.27px white solid">
        </div>
        <div style="width: 43.94px; height: 21px; left: 377px; top: 5px; position: absolute">
            <div style="width: 24.59px; height: 21px; left: 0px; top: 0px; position: absolute">
                <div
                    style="width: 10.24px; height: 10.24px; left: 7.17px; top: 0px; position: absolute; background: #F03C43; border-radius: 9999px; border: 0.46px white solid">
                </div>
                <div style="width: 24.59px; height: 10.24px; left: 0px; top: 10.76px; position: absolute">
                    <div
                        style="width: 10.24px; height: 10.24px; left: 0px; top: 0px; position: absolute; background: white; border-radius: 9999px; border: 0.46px white solid">
                    </div>
                    <div
                        style="width: 10.24px; height: 10.24px; left: 14.34px; top: -0px; position: absolute; background: #001829; border-radius: 9999px; border: 0.46px white solid">
                    </div>
                </div>
            </div>
            <div
                style="width: 17.21px; height: 11.68px; left: 26.73px; top: 4.92px; position: absolute; color: #1E1E1E; font-size: 7.40px; font-family: Roboto; font-weight: 400; word-wrap: break-word">
                +14</div>
        </div>
    </div>
    <div
        style="left: 15.83px; top: 468px; position: absolute; color: black; font-size: 16px; font-family: Industry; font-weight: 500; text-transform: uppercase; line-height: 16px; word-wrap: break-word">
        product title</div>
    <div style="left: 304px; top: 464px; position: absolute">
        <div
            style="left: 64px; top: 0px; position: absolute; color: #F03C43; font-size: 20px; font-family: Industry; font-weight: 700; text-transform: uppercase; line-height: 20px; word-wrap: break-word">
            $00.00</div>
        <div
            style="left: 0px; top: 4px; position: absolute; color: black; font-size: 16px; font-family: Industry; font-weight: 500; text-decoration: line-through; text-transform: uppercase; line-height: 16px; word-wrap: break-word">
            $00.00</div>
    </div>
    <div style="width: 420.60px; height: 0px; left: 16px; top: 498px; position: absolute; border: 0.65px #171717 solid">
    </div>
    <div style="width: 89.13px; height: 11.31px; left: 16px; top: 512px; position: absolute">
        <div style="width: 11.81px; height: 11.31px; left: 77.32px; top: 0px; position: absolute; background: black">
        </div>
        <div style="width: 11.81px; height: 11.31px; left: 57.99px; top: 0px; position: absolute; background: black">
        </div>
        <div style="width: 11.81px; height: 11.31px; left: 38.66px; top: 0px; position: absolute; background: black">
        </div>
        <div style="width: 11.81px; height: 11.31px; left: 19.33px; top: 0px; position: absolute; background: black">
        </div>
        <div style="width: 11.81px; height: 11.31px; left: 0px; top: 0px; position: absolute; background: black">
        </div>
    </div>
    <div style="width: 82px; height: 23px; left: 16px; top: 18px; position: absolute">
        <div style="width: 82px; height: 23px; left: 0px; top: 0px; position: absolute; background: #F03C43">
        </div>
        <div
            style="width: 51px; height: 11px; left: 16px; top: 6px; position: absolute; color: white; font-size: 12px; font-family: Industry; font-weight: 600; text-transform: uppercase; line-height: 9.60px; letter-spacing: 0.60px; word-wrap: break-word">
            20% off</div>
    </div>
    <div style="width: 110px; height: 23px; left: 16px; top: 49px; position: absolute">
        <div style="width: 110px; height: 23px; left: 0px; top: 0px; position: absolute; background: #001829">
        </div>
        <div
            style="width: 83px; height: 11px; left: 14px; top: 6px; position: absolute; text-align: center; color: white; font-size: 12px; font-family: Industry; font-weight: 600; text-transform: uppercase; line-height: 9.60px; letter-spacing: 0.60px; word-wrap: break-word">
            bestseller</div>
    </div> -->
</div>